import React from 'react';
import _ from 'lodash';
import AndroidIcon from '@mui/icons-material/Android';
import useAppInfo from '../../../hooks/appInfo.hook';
import DashboardLayout from "../../../layouts/Dashboard";
import FirstPublish from './FirstPublish/Index';
import UpdatePublish from './UpdatePublish';

export default function PublishAndroid() {
    const { appInfo } = useAppInfo();

    return (
        <DashboardLayout
            Icon={AndroidIcon}
            title="Aplicativo Android"
            subtitle="Envie a versão Android do seu aplicativo para o Google Play Store"
        >
            {appInfo.androidDownloadUrl
              ? <UpdatePublish />
              : <FirstPublish />
            }
        </DashboardLayout >
    )
}